import { createSlice } from "@reduxjs/toolkit";
import { setCreateAccountDataReducer } from "./reducer";

const initialState = {
  createAccountData: {
    verifyIdentity: {},
    countryCitizenship: {},
    residentialAddress: {},
    employeeStatus: "",
    annualIncome: "",
    fundingSourse: "",
    netWorth: "",
    affiliation: {},
    isPhoneVerified: false,
  },
};

export const surmountAccountSlice = createSlice({
  name: "surmountAccount",
  initialState,
  reducers: {
    setCreateAccountData: setCreateAccountDataReducer,
  },
});

export const { setCreateAccountData } = surmountAccountSlice.actions;
export default surmountAccountSlice.reducer;
